import { Board, CellState, cellValueBits, withValueBits } from '@puzzlio/core';

export type EmptyCellValue = 0;
export type XCellValue = 1;
export type StarCellValue = 2;
export type CellValue = StarCellValue | EmptyCellValue | XCellValue; // empty, X, star

/** Extract the Stars CellValue (bits 0–1) from a CellState. */
export const cellValue = (cell: CellState): CellValue => cellValueBits(cell) as CellValue;

/**
 * Build a fresh CellState with the given value and colour index (0 = no highlight).
 * Edge bits are always 0 for a newly created cell.
 */
export const makeState = (value: CellValue, colorIndex: number = 0): CellState => value | ((colorIndex & 0x03) << 2);

/** Replace only the CellValue bits (0–1) while preserving all other bits (colour + edges). */
export const setValueBits = (state: CellState, value: CellValue): CellState => withValueBits(state, value);

export type Regions = number[][];

export interface StarsBoard extends Board {
  regions: Regions;
  solution: CellValue[][];
  /** How many stars go in each row, column and region: two for a daily, three for some challenges. */
  starsPerUnit: number;
}

/** How many stars a solution puts in each row, column and region; two for a board without one. */
export const starsPerUnitOf = (solution: CellValue[][] | undefined): number =>
  solution?.[0]?.filter((cell) => cell === 2).length || 2;
